var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',{style:({ position: 'fixed', zIndex: 1, width: '100%' })},[_c('div',{staticClass:"flex justify-content-between align-items-center w-full"},[_c('div',{staticClass:"flex align-items-center gap-3"},[_c('layout-project')],1),_c('layout-header-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }